<template>
  <div v-if="similars && similars.length" class="col-md-12">
    <div class="mb-2 font-italic font-weight-bold">
      <i class="fas fa-vials"></i>
      {{ similarText }}
    </div>
    <div class="form-row">
      <div
        v-for="(item, i) in similars"
        :key="`similar-${i}`"
        class="col-md-3 col-6"
      >
        <div class="card">
          <div class="card-body p-2 overflow-hidden">
            <router-link
              :to="{ name: 'IdeaDetail', params: { id: item.Id } }"
              class="card-title h6 text-dark mb-2 text-nowrap"
              target="_blank"
            >
              <i class="fas fa-lightbulb"></i> &nbsp;
              {{ item.Title }}
            </router-link>
            <p class="card-text overflow-hidden mb-2" style="height: 62px">
              {{ item.Description }}
            </p>
            <p class="card-text text-muted small mb-2">
              <i class="fas fa-user"></i>
              By
              {{
                item.IsAnonymous
                  ? "Anonymous"
                  : item.CreatedByNavigation.FirstName
              }}
              |
              <i class="fas fa-globe"></i>
              {{ item.Area.Name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title"],
  data() {
    return {
      similars: [],
      similarText: "Your challenge may be similar to the challenges below",
      timeoutQuery: null,
      loading: false,
    };
  },
  watch: {
    title() {
      if (!this.timeoutQuery) {
        this.loading = true;
        this.timeoutQuery = setTimeout(
          () => this.getSimilarItems(this.title),
          3000
        );
      } else if (!this.loading) {
        clearTimeout(this.timeoutQuery);
        this.timeoutQuery = null;
      }
    },
    similars(val) {
      this.$emit("updateText", val && val.length ? this.similarText : null);
    },
  },
  methods: {
    async getSimilarItems(title) {
      this.loading = true;
      let result = [];
      try {
        if (title) {
          let words =
            title.includes(" ") && title.split(" ").length
              ? title.split(" ").filter((_) => _)
              : [title];
          if (words && words.length) {
            let filters = [];

            words.forEach((word) => {
              filters.push(
                `(contains(Title, '${word}') or contains(Description, '${word}'))`
              );
            });
            let resp = await this.$http.get(`odata/SipChallenge`, {
              params: {
                $top: 4,
                $filter: filters.join(" and "),
                $select:
                  "Id,Title,Description,AreaId,AttachedFiles,IsAnonymous,Status",
                $expand:
                  "CreatedByNavigation($select=FirstName),Area($select=Name)",
              },
            });
            if (resp && resp.status == 200) {
              result = resp.data.value;
            }
          }
        }
      } catch {
        //
      }

      this.loading = false;
      this.similars = result;
    },
  },
};
</script>